import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './auth/reducer';
import transactionReducer from './transaction/transactionSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  transaction: transactionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
